<template>
    <div class="col">

        <div id="main"
             class="col-main">

            <div class="row no-gutters row-main justify-content-center">

                <div class="col-12 col-lg-10 bg-white">

                    <div class="row no-gutters justify-content-center">
                        <div class="col-12 col-lg-9">
                            <h2 class="section-title">Ealing Trailfinders Cricket Club</h2>
                        </div>

                        <div class="col-12 col-lg-9">
                            <!-- Text -->
                            <p class="h5">Ealing Trailfinders Cricket Club play at the impressive Trailfinders 
                            Sports Club, with the best cricket facilities in the area. </p> <br>
                            <ul>
                                <li>All Weather Indoor Centre, including a 3-bay net with viewing 
                                    gallery with disabled access.</li>
                                <li>Outdoor 3-bay net facility, with bowling machine.</li>
                                <li>A dedicated cricket pavilion</li>
                                <li>16 pitch square</li>
                                <li>Mobile nets</li>
                                <li>Training Kit</li>
                                <li>Ample parking</li>
                                <li>Multi sports facilities (at extra cost)</li>
                                <li>Gym (at extra cost)</li>
                            </ul>
                            <br>
                            <!-- Btn -->
                            <!-- <div class="row justify-content-between my-4">
                                <div class="col-auto ">
                                    <a href="pdfs/02734_TFSC_Cricket_Pavilion_Plan.pdf"
                                       target="_blank"
                                       class="btn btn-more btn-has-icon-left"><i class="material-icons">visibility</i>View
                                Floor
                                                                                                                      Plan</a>
                                </div>
                            </div> -->

                            <div class="alert alert-light">
                                <p>Our cricket square is immaculately kept by full-time groundsmen 
                        and is fully equipped with an electronic scoreboard, covers and sight screens. 
                        For spectators bleachers are available to watch the games.</p>
                            </div>
                        </div>

                        <div class="col-12 col-lg-9">

                            <!-- <ul class="list-group list-group-flush">
                                <li class="list-group-item">
                                    <h2 class="section-title">Trailfinders sports club – No better venue</h2>
                                    <p class="h5">Trailfinders Sports Club prides itself on the excellence of its
                                                  sporting facilities and with 20 acres of landscaped grounds at your
                                                  disposal there is so much to choose from.</p>
                                    <p>Modern and versatile, all our sports facilities and buildings can be hired by the
                                       hour, by the match or by the day, perfect for weekly games sessions and fixtures,
                                       sports days, corporate events, weddings and meetings. There really is something
                                       for everyone at the club whether you are a business, school, club or
                                       individual.</p>
                                    <p>In addition to the Cricket Facilities we also have a range of other facilities on
                                       site:</p>
                                    <ul class="mt-3">
                                        <li><a href="#"
                                               class="text-dark">Olympic Pavilion </a></li>
                                        <li><a href="#"
                                               class="text-dark">Centenary Club House </a></li>
                                        <li><a href="#"
                                               class="text-dark">Mini Pavillion </a></li>
                                    </ul>
                                    <ul class="mt-3">
                                        <li>2 full size 3G all weather rugby pitches and grandstand - floodlit</li>
                                        <li>2 grass rugby pitches</li>
                                        <li>Minis rugby pitch</li>
                                        <li>4 floodlit tennis courts/netball courts - floodlit</li>
                                        <li>3G all weather 5/7- a-side football/training pitch - floodlit</li>
                                        <li>3 softball squares</li>
                                        <li>Fitness centre</li>
                                        <li>Male & female changing rooms, lockers and showers</li>
                                    </ul>
                                </li>
                                <li class="list-group-item">
                                    <h2 class="section-title">Private Hire</h2>
                                    <p>Overlooking the playing fields of Trailfinders Sports Club the cricket pavilion
                                       makes an attractive venue for private hire, perfect for small summer parties,
                                       corporate team building and company cricket or softball matches. Trailfinders
                                       Sports Club is able to provide a high standard of catering and a wide variety of
                                       menus to suit any occasion. For more information contact Trailfinders Sports Club
                                       direct on 020 8998 7928 or email enquiries@tfsc.co.uk</p>
                                </li>
                            </ul> -->
                            <br>
                            <h2 class="section-title">Welcome to Trailfinders Sports Club</h2>
                            <h4>Conferences, Meetings, Corporate Events, 
                            Weddings, Parties & Sport Facilities</h4>
                            <p>Trailfinders Sports Club is one of West London’s premier function venues, 
                            boasting outstanding hospitality and sporting facilities at competitive 
                            rates.</p>
                            <p>This versatile venue, set in 20 acres with 3 modern pavilions, is perfect for
                            conferences, meetings, corporate events, weddings, parties and other 
                            special occasions. Our experienced event management team are on hand 
                            with a professional and personalised service to ensure your occasion is a 
                            huge success.</p>
                            <p>Trailfinders Sports Club is home to Ealing Trailfinders Rugby and Cricket 
                                courts, 5/7-a-side football/hockey pitch and gym are ideal for corporate 
                                events, sports days, weekly games sessions and fixtures whether you are 
                                a business, school, club or individual.</p>
                            <p>Conveniently located in West Ealing with ample free parking, easy access 
                                from the M40 and M4 and close to public transport, you need look no 
                                further for your corporate, social or sporting needs.</p>
                            <p>For more details visit <a href="https://www.tfsc.co.uk">https://www.tfsc.co.uk </a>or ring 0208 998 7928</p>


                            <h5></h5>








                        </div>

                    </div>

                </div>

            </div>

        </div>

    </div>
</template>
<script>
    export default {
        // data() {
        //     return {
        //         model: {}
        //     }
        // },
        // methods: {
        //     fetchList() {
        //         fetchUser('5e42c8d3a366ce0f8dfc4bf9')
        //             .then(response => {
        //                 this.model = response;
        //             })
        //     },
        // }
    }
</script>
<style>
</style>
